import { FC } from "react";
import { Image, Panel } from "capitalrx-components-2.0/lib/general";
import { Grid, Stack } from "capitalrx-components-2.0/lib/layout";
import { Paragraph } from "capitalrx-components-2.0/lib/typography";
import ImagePiggybank from "@/static/images/piggybank.svg?url";
import ImageCoin from "@/static/images/coin.svg?url";
import ImageData from "@/static/images/data.svg?url";

import styles from "./cardSectionStyles.module.scss";

const BetterRXCards: FC = () => {
  return (
    <div className={styles.BetterRXCards}>
      <Grid className={styles.BetterRXCardsContainer}>
        <Grid.Spread columns={4}>
          <div className={styles.BetterRXCardsItems}>
            <Panel className={styles.BetterRXCardsItemsWrapper} testId="card-piggybank">
              <Stack alignment="center">
                <Image src={ImagePiggybank} alt="piggybank" aria-hidden="true" />
                <Paragraph className={styles.BetterRXCardsText} textAlign="center">Get consistent, low pricing every visit</Paragraph>
              </Stack>
            </Panel>
          </div>
        </Grid.Spread>
        <Grid.Spread columns={4}>
          <div className={styles.BetterRXCardsItems}>
            <Panel className={styles.BetterRXCardsItemsWrapper} testId="card-coin">
              <Stack alignment="center">
                <Image src={ImageCoin} alt="coin" aria-hidden="true" />
                <Paragraph className={styles.BetterRXCardsText} textAlign="center">Stop paying hidden fees (~$7 / script)</Paragraph>
              </Stack>
            </Panel>
          </div>
        </Grid.Spread>
        <Grid.Spread columns={4}>
          <div className={styles.BetterRXCardsItems}>
            <Panel className={styles.BetterRXCardsItemsWrapper} testId="card-data">
              <Stack alignment="center">
                <Image src={ImageData} alt="data" aria-hidden="true" />
                <Paragraph className={styles.BetterRXCardsText} textAlign="center">We never sell your data to 3rd parties</Paragraph>
              </Stack>
            </Panel>
          </div>
        </Grid.Spread>
      </Grid>
    </div>
  );
};

export default BetterRXCards;
